import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SystemSection } from './components/SystemSection';
import { BonusesSection } from './components/BonusesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const PIXEL_ID = '2226605141499138';
export function App() {
  useEffect(() => {
    if (window.fbq) return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const first = document.getElementsByTagName('script')[0];
    first?.parentNode?.insertBefore(script, first);
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen w-full bg-navy font-sans text-ivory selection:bg-gold selection:text-navy" data-id="element-0" data-mp="33mow1rfx4mpj">
      <noscript data-id="element-1" data-mp="38m1e7yvuh5ls">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="38li7zffk45nl" />
      </noscript>

      <Hero data-id="element-3" data-mp="nur8q7by6l0i" />
      <main data-id="element-4" data-mp="nvaqno1ll9ej">
        <ProblemSection data-id="element-5" data-mp="nxn4pq48izmb" />
        <SystemSection data-id="element-6" data-mp="sudk0b87tr6o" />
        <BonusesSection data-id="element-7" data-mp="stub1k0jmd4s" />
        <BenefitsSection data-id="element-8" data-mp="st2iki28sviq" />
        <PricingSection data-id="element-9" data-mp="swgkjp6zv2pn" />
        <GuaranteeSection data-id="element-10" data-mp="35yq6nee9s31" />
        <TestimonialsSection data-id="element-11" data-mp="35ghgrajple8" />
        <FAQSection data-id="element-12" data-mp="38kwkjpju1jo" />
        <FinalCTA data-id="element-13" data-mp="3uct25gan0gyw" />
      </main>
      <Footer data-id="element-14" data-mp="3udkmtw2p4uae" />
      <PurchasePopup data-id="element-15" data-mp="3ubzumd3utnfp" />
    </div>;
}